import { useState, useCallback } from 'react';
import auditLogsService from '../services/auditLogsService';

const useAuditLogs = () => {
  const [logs, setLogs] = useState([]);
  const [timeline, setTimeline] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchOrderAuditLogs = useCallback(async (orderId) => {
    setLoading(true);
    setError(null);
    const res = await auditLogsService.getOrderAuditLogs(orderId);
    if (res.success) {
      setLogs(res.data || []);
    } else {
      setError(res.error);
      setLogs([]);
    }
    setLoading(false);
    return res;
  }, []);

  const fetchPurchaseOrderAuditLogs = useCallback(async (poId) => {
    setLoading(true);
    setError(null);
    const res = await auditLogsService.getPurchaseOrderAuditLogs(poId);
    if (res.success) {
      setLogs(res.data || []);
    } else {
      setError(res.error);
      setLogs([]);
    }
    setLoading(false);
    return res;
  }, []);

  const fetchDeliverySubOrderAuditLogs = useCallback(async (subOrderId) => {
    setLoading(true);
    setError(null);
    const res = await auditLogsService.getDeliverySubOrderAuditLogs(subOrderId);
    if (res.success) {
      setLogs(res.data || []);
    } else {
      setError(res.error);
      setLogs([]);
    }
    setLoading(false);
    return res;
  }, []);

  const fetchPurchaseAdviceAuditLogs = useCallback(async (adviceId) => {
    setLoading(true);
    setError(null);
    const res = await auditLogsService.getPurchaseAdviceAuditLogs(adviceId);
    if (res.success) {
      setLogs(res.data || []);
    } else {
      setError(res.error);
      setLogs([]);
    }
    setLoading(false);
    return res;
  }, []);

  const fetchInquiryAuditLogs = useCallback(async (inquiryId) => {
    setLoading(true);
    setError(null);
    const res = await auditLogsService.getInquiryAuditLogs(inquiryId);
    if (res.success) {
      setLogs(res.data || []);
    } else {
      setError(res.error);
      setLogs([]);
    }
    setLoading(false);
    return res;
  }, []);

  const fetchOrderTimeline = useCallback(async (orderId) => {
    setLoading(true);
    setError(null);
    const res = await auditLogsService.getOrderTimeline(orderId);
    if (res.success) {
      setTimeline(res.data || []);
    } else {
      setError(res.error);
      setTimeline([]);
    }
    setLoading(false);
    return res;
  }, []);

  const fetchPurchaseOrderTimeline = useCallback(async (poId) => {
    setLoading(true);
    setError(null);
    const res = await auditLogsService.getPurchaseOrderTimeline(poId);
    if (res.success) {
      setTimeline(res.data || []);
    } else {
      setError(res.error);
      setTimeline([]);
    }
    setLoading(false);
    return res;
  }, []);

  const reset = useCallback(() => {
    setLogs([]);
    setTimeline([]);
    setError(null);
    setLoading(false);
  }, []);

  return {
    logs,
    timeline,
    loading,
    error,
    fetchOrderAuditLogs,
    fetchPurchaseOrderAuditLogs,
    fetchDeliverySubOrderAuditLogs,
    fetchPurchaseAdviceAuditLogs,
    fetchInquiryAuditLogs,
    fetchOrderTimeline,
    fetchPurchaseOrderTimeline,
    reset,
  };
};

export default useAuditLogs;
